import { render, staticRenderFns } from "./HoroscopeGenerationPanel.vue?vue&type=template&id=b27f45b6&scoped=true&"
import script from "./HoroscopeGenerationPanel.vue?vue&type=script&lang=js&"
export * from "./HoroscopeGenerationPanel.vue?vue&type=script&lang=js&"
import style0 from "./HoroscopeGenerationPanel.vue?vue&type=style&index=0&id=b27f45b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27f45b6",
  null
  
)

export default component.exports